export const PIXEL_ENVIRONMENTS = ['stg', 'prod'];
